import { useCallback } from "react";
import { useShowNotification } from "@/shared/components/Notifications";

// `onNotify` for <TextJamEditor>: renders editor toasts with the app's notistack.
export const useTextJamNotify = () => {
  const showNotification = useShowNotification();

  return useCallback(({ type, message, options }) => {
    showNotification(message, type, {
      key: options?.id,
      persist: options?.persist,
      preventDuplicate: !!options?.id,
    });
  }, [showNotification]);
};
